
































import { Geolocation } from '~/models/common/types'
import {
  defineComponent,
  PropType,
  ref,
  computed,
  watch
} from '~/utils/nuxt3-migration'
import useRuntimeConfig from '~/compositions/useRuntimeConfig'

export default defineComponent({
  props: {
    loadWhenVisible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    },
    allowFullScreen: {
      type: Boolean,
      default: true
    },
    marker: {
      type: Object as PropType<Geolocation>,
      required: true
    },
    mode: {
      type: String as PropType<'place' | 'view'>,
      default: 'place'
    },
    zoom: {
      type: [Number, String],
      default: 15
    }
  },
  setup(props) {
    const {
      public: { googleMapsEmbedApiKey }
    } = useRuntimeConfig()

    const shouldLoad = ref(!props.loadWhenVisible)
    const mapRef = ref(null)

    watch(
      () => props.marker,
      (value: Geolocation, prevValue: Geolocation) => {
        if (value.lat === prevValue.lat && value.lon === prevValue.lon) {
          return
        }
        reload()
      }
    )

    const iframeSrc = computed(() => {
      let url = `https://www.google.com/maps/embed/v1/${props.mode}?key=${googleMapsEmbedApiKey}&zoom=${props.zoom}`

      if (props.mode === 'place') {
        url += `&q=${props.marker.lat},${props.marker.lon}`
      } else if (props.mode === 'view') {
        url += `&center=${props.marker.lat},${props.marker.lon}`
      }

      return url
    })

    function handleContainerVisible(visible: boolean) {
      if (!visible || !props.loadWhenVisible) {
        return
      }

      shouldLoad.value = true
    }

    function reload() {
      if (!mapRef.value) {
        return
      }

      const display = mapRef.value.style.display

      mapRef.value.style.display = 'none'
      mapRef.value.style.display = display
    }

    return { shouldLoad, mapRef, iframeSrc, handleContainerVisible }
  }
})
